import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IFeedback } from './Feedback.types';

@Identifiable
@Timestampable
@Untrackable
export class Feedback extends AbstractDocument<IFeedback> {
  readonly collections = {};

  readonly translatable = (data: IFeedback): NonNullable<IFeedback['_translations']>[string] => ({
    body: data.body,
    response: {
      message: data.response?.message,
    },
    title: data.title,
  });
}

export class FeedbackCollection extends AbstractCollection<Feedback, IFeedback> {
  static path = 'feedback';

  constructor(document: Supplier) {
    super(document.collection(FeedbackCollection.path), Feedback);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
